import React from "react";
import { Modal, Icon, Button, Divider, Header, Image } from "semantic-ui-react";

interface Props {
  open: boolean;
  onClose: () => void;
}

const PrivacyPolicyModal = ({ open, onClose }: Props) => (
  <Modal open={open} onClose={onClose} scrolling style={{ borderRadius: 10, border: "1px solid #082933" }}>
    <Modal.Header style={{ position: "relative", borderRadius: "10px 10px 0 0" }}>
      Política de Privacidad y Tratamiento de Datos Personales
      <a
        href="#"
        onClick={(e) => { e.preventDefault(); onClose(); }}
        style={{ position: "absolute", top: "50%", right: "1em", transform: "translateY(-50%)", lineHeight: 1 }}
      >
        <Icon name="close" size="small" style={{ color: "#999", margin: 0 }} />
      </a>
    </Modal.Header>

    <Modal.Content style={{ borderRadius: "0 0 10px 10px" }}>
      <Image src="/majimeLogo.png" size="small" centered style={{ marginBottom: "1em" }} />

      <p style={{ color: "#666", fontSize: "0.9em", textAlign: "center" }}>
        Última actualización: {new Date().getFullYear()}
      </p>

      <Header as="h4" style={{ color: "#082933" }}>1. Responsable del Tratamiento</Header>
      <p>
        <strong>Majim-e</strong>, con plataforma disponible en{" "}
        <a href="https://majim-e.co" target="_blank" rel="noreferrer">majim-e.co</a>, es
        responsable del tratamiento de los datos personales recopilados a través de su plataforma
        de facturación electrónica, en cumplimiento de la{" "}
        <strong>Ley 1581 de 2012</strong> y el <strong>Decreto 1377 de 2013</strong> de Colombia.
      </p>

      <Header as="h4" style={{ color: "#082933" }}>2. Datos Personales Recopilados</Header>
      <p>
        La Empresa recopila los datos personales necesarios para la prestación del servicio de
        facturación electrónica, incluyendo datos de identificación, contacto, acceso, información
        empresarial y datos derivados de la operación en la plataforma, conforme a lo establecido
        por la normativa colombiana vigente.
      </p>

      <Header as="h4" style={{ color: "#082933" }}>3. Finalidad del Tratamiento</Header>
      <p>Los datos personales recopilados serán utilizados para:</p>
      <ul>
        <li>Prestar el servicio de facturación electrónica conforme a la normativa de la DIAN.</li>
        <li>Gestionar el acceso y autenticación de usuarios en la plataforma.</li>
        <li>Emitir, transmitir y almacenar documentos electrónicos.</li>
        <li>Enviar notificaciones relacionadas con el estado de los documentos.</li>
        <li>Cumplir con obligaciones legales y requerimientos de entidades gubernamentales.</li>
        <li>Mejorar la calidad y el funcionamiento del servicio.</li>
        <li>Enviar comunicaciones de soporte técnico y actualizaciones del servicio.</li>
      </ul>

      <Header as="h4" style={{ color: "#082933" }}>4. Base Legal del Tratamiento</Header>
      <p>El tratamiento de datos personales se realiza bajo las siguientes bases legales:</p>
      <ul>
        <li>
          <strong>Consentimiento:</strong> al registrarse y utilizar la plataforma, el titular
          otorga su consentimiento expreso para el tratamiento de sus datos.
        </li>
        <li>
          <strong>Obligación legal:</strong> el procesamiento de documentos electrónicos ante
          la DIAN es una obligación tributaria establecida por la legislación colombiana.
        </li>
        <li>
          <strong>Ejecución contractual:</strong> el tratamiento es necesario para la prestación
          del servicio contratado.
        </li>
      </ul>

      <Header as="h4" style={{ color: "#082933" }}>5. Derechos del Titular</Header>
      <p>
        De conformidad con la Ley 1581 de 2012, el titular de los datos tiene los siguientes
        derechos:
      </p>
      <ul>
        <li>Conocer, actualizar y rectificar sus datos personales.</li>
        <li>Solicitar prueba de la autorización otorgada.</li>
        <li>Ser informado sobre el uso que se ha dado a sus datos personales.</li>
        <li>Presentar quejas ante la Superintendencia de Industria y Comercio (SIC).</li>
        <li>Revocar la autorización y/o solicitar la supresión de sus datos.</li>
        <li>Acceder gratuitamente a sus datos personales.</li>
      </ul>
      <p>
        Para ejercer estos derechos, puede comunicarse con nosotros a través de{" "}
        <a href="https://majim-e.co" target="_blank" rel="noreferrer">majim-e.co</a>.
      </p>

      <Header as="h4" style={{ color: "#082933" }}>6. Conservación de los Datos</Header>
      <p>
        Los datos personales serán conservados durante el tiempo que sea necesario para cumplir
        con las finalidades descritas en esta política y conforme a las obligaciones legales
        aplicables. Los documentos electrónicos se conservan por un mínimo de{" "}
        <strong>cinco (5) años</strong>, según lo establecido por la normativa tributaria colombiana.
      </p>

      <Header as="h4" style={{ color: "#082933" }}>7. Seguridad de la Información</Header>
      <p>
        La Empresa adopta medidas técnicas, administrativas y físicas para proteger los datos
        personales contra acceso no autorizado, pérdida, alteración o divulgación. Entre estas
        medidas se incluyen cifrado de contraseñas, autenticación mediante tokens JWT, conexiones
        seguras HTTPS y control de acceso basado en roles.
      </p>

      <Header as="h4" style={{ color: "#082933" }}>8. Transferencia de Datos a Terceros</Header>
      <p>
        Los datos personales no serán vendidos ni cedidos a terceros con fines comerciales.
        Podrán ser compartidos únicamente con:
      </p>
      <ul>
        <li>
          La <strong>DIAN</strong>, en cumplimiento de las obligaciones de facturación electrónica.
        </li>
        <li>
          Proveedores de servicios tecnológicos que actúen como encargados del tratamiento, bajo
          acuerdos de confidencialidad.
        </li>
        <li>Autoridades competentes cuando sea requerido por ley.</li>
      </ul>

      <Header as="h4" style={{ color: "#082933" }}>9. Cookies y Tecnologías de Seguimiento</Header>
      <p>
        La plataforma utiliza almacenamiento local del navegador (localStorage) para gestionar
        la sesión del usuario de forma segura. No se utilizan cookies de rastreo publicitario
        de terceros.
      </p>

      <Header as="h4" style={{ color: "#082933" }}>10. Modificaciones a esta Política</Header>
      <p>
        La Empresa se reserva el derecho de actualizar esta Política de Privacidad en cualquier
        momento. Los cambios serán notificados a través de la plataforma y/o al correo electrónico
        registrado. El uso continuado del servicio después de la notificación constituye aceptación
        de los cambios.
      </p>

      <Header as="h4" style={{ color: "#082933" }}>11. Contacto</Header>
      <p>
        Para consultas, solicitudes o reclamos relacionados con el tratamiento de sus datos
        personales, puede comunicarse con nosotros a través de{" "}
        <a href="https://majim-e.co" target="_blank" rel="noreferrer">majim-e.co</a>.
      </p>

      <Divider />

      <Button fluid color="blue" onClick={onClose}>
        <Icon name="close" /> Cerrar
      </Button>
    </Modal.Content>
  </Modal>
);

export default PrivacyPolicyModal;
